import { useState } from "react";
import { UrgentCareEncounterCard } from "~/features/dashboard/pages/encounters/components/urgentcare-card";
import { FormattedEncounter } from "~/features/dashboard/pages/encounters/types";
import { formatFullDate, formatEncounterFullTime, formatToMonthDayYear } from "@workspace/lib/date";
import { MedicalRefillsSheet } from "~/features/dashboard/components/refills/refill-sheet";

export const Refills = ({ refillsData, patientData }: { refillsData: any; patientData?: any }) => {
  
  const [selectedEncounter, setSelectedEncounter] = useState<FormattedEncounter | null>(null);
  const [isRefillSheetOpen, setIsRefillSheetOpen] = useState(false);
  
  // Handle both possible data structures
  const refills = refillsData?.refills || refillsData?.patient_summary || [];
  
  // Transform refills to FormattedEncounter format
  const formattedRefills: FormattedEncounter[] = refills.map((refill: any) => {
    const refillDate = refill.request_date || refill.request_datetime || refill.created_at || "";
    
    return {
      id: refill.refill_id || refill.id,
      type: "refill",
      encounterId: refill.refill_id || refill.id || "",
      title: patientData?.name ? `${patientData.name} Refill Request` : "Refill Request",
      description: "Medication Refill Request",
      date: refillDate ? formatFullDate(refillDate) : "",
      time: refillDate ? formatEncounterFullTime(refillDate) : "No Time Available",
      createdAt: refillDate ? formatToMonthDayYear(refillDate) : "",
      instanceCreated: refillDate,
    is_consultation: false,
    medicalRefills: refill.medication_name ? [{
      name: refill.medication_name,
      dosage: refill.medication_dosage || ""
    }] : undefined,
    patient: {
      id: patientData?.userId || patientData?.user_id || "",
      name: patientData?.name || "",
      gender: patientData?.gender || "",
      age: patientData?.age || 0,
      email: patientData?.email || "",
      glp1_guide_accepted: patientData?.glp1_guide_accepted || false,
      identity_verified: patientData?.identity_verified || false,
      urgent_care_onboarded: patientData?.urgent_care_onboarded || false,
      user_dosespot_id: patientData?.user_dosespot_id || "",
    },
      status: refill.status || refill.refill_status || "requested",
      tag: refill.status || refill.refill_status || "Requested",
    };
  });

  const handleRefillSheetClose = (open: boolean) => {
    setIsRefillSheetOpen(open);
    if (!open) {
      setSelectedEncounter(null);
    }
  };

  if (!refills || refills.length === 0) {
    return (
      <div className="flex flex-col gap-2 p-4">
        <p className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">No refills found</p>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col gap-4">
        {formattedRefills.map((refill) => (
          <UrgentCareEncounterCard
            key={refill.id}
            item={refill}
            program="urgent-care"
            selectedEncounter={selectedEncounter}
            setSelectedEncounter={setSelectedEncounter}
            onOpenChange={setIsRefillSheetOpen}
          />
        ))}
      </div>
      {isRefillSheetOpen && selectedEncounter && selectedEncounter?.id && (
        <MedicalRefillsSheet
          open={isRefillSheetOpen}
          onOpenChange={handleRefillSheetClose}
          refillId={selectedEncounter.id}
          userDosespotId={selectedEncounter?.patient?.user_dosespot_id ?? patientData?.user_dosespot_id}
          sessionId={selectedEncounter?.id}
          encounterId={selectedEncounter?.encounterId}
          urgent_care_onboarded={selectedEncounter?.patient?.urgent_care_onboarded}
          recommendedTasks={selectedEncounter.recommendedTasks}
        />
      )}
    </>
  );
}
